module.exports = __webpack_public_path__ + "static/img/bot.53ca479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bot.png
// module id = ABIr
// module chunks = 6